/** 业务 API（登录、用户等），与 PDF 服务地址分离 */
const HTTP_REQUEST_URL =
  process.env.VUE_APP_HTTP_BASE || 'https://api.aiyqzx.com/app/v1/'

module.exports = {
  HTTP_REQUEST_URL,
  FILE_UPLOAD_URL: `${HTTP_REQUEST_URL.replace(/\/$/, '')}/file`,
  // TODO: Set the backend STS endpoint. Never expose permanent COS secrets in the frontend.
  COS_STS_API: process.env.VUE_APP_COS_STS_API || '',
  COS_BUCKET: process.env.VUE_APP_COS_BUCKET || '',
  COS_REGION: process.env.VUE_APP_COS_REGION || '',
  TOKEN_NAME: 'token'
}
